<template>
  <div>
    <router-view></router-view>
  </div>
</template>


<script>
export default {
  name: "app",
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
@import "../src/assets/scss/el-ui.scss";

//add new

@import "../node_modules/toastr/build/toastr.css";
@import "../node_modules/element-ui/lib/theme-chalk/index.css";
@import "../node_modules/nprogress/nprogress.css";
@import "../src/assets/scss/ladda.min.css";
@import "../src/assets/scss/nprogress.css";
@import "../src/assets/fontawesome/css/all.css";

@font-face {
  font-family: "Nunito";
  src: url("./fonts/Nunito.ttf");
}
body {
  font-family: "Nunito", "Courier New", Courier, monospace;
  font-size: 16px;
}
</style>
